import { apiFetch, type AjaxResult } from './http';
import type { AppOrderResults, MhOrderRow } from '@/types/mh';

export type CreateOrderResult = {
  orderNo: string;
  productType?: string;
  status?: string;
  responseJson?: string;
  apiError?: string;
  pointsCharged?: number;
  consumeMode?: string;
};

export type OrderApiResult = {
  orderNo: string;
  productName?: string;
  status?: string;
  responseJson?: string;
};

export async function fetchOrderSubmitMode(): Promise<AjaxResult<{ jumpCustomerService: boolean }>> {
  return apiFetch<{ jumpCustomerService: boolean }>('/api/app/order/submitMode', { method: 'GET' });
}

export async function createOrderApi(body: {
  productId: number;
  params: Record<string, string>;
}): Promise<AjaxResult<CreateOrderResult>> {
  return apiFetch<CreateOrderResult>('/api/app/order/create', {
    method: 'POST',
    body: JSON.stringify(body),
    auth: true,
  });
}

export async function fetchOrderApiResult(orderNo: string): Promise<AjaxResult<OrderApiResult>> {
  return apiFetch<OrderApiResult>(`/api/app/order/${encodeURIComponent(orderNo)}/apiResult`, {
    method: 'GET',
    auth: true,
  });
}

export async function fetchMyOrders(): Promise<AjaxResult<MhOrderRow[]>> {
  return apiFetch<MhOrderRow[]>('/api/app/order/list', { method: 'GET', auth: true });
}

export async function fetchRecentOrders(limit = 5): Promise<AjaxResult<MhOrderRow[]>> {
  const q = new URLSearchParams({ limit: String(limit) });
  return apiFetch<MhOrderRow[]>(`/api/app/order/recent?${q}`, { method: 'GET', auth: true });
}

export async function fetchOrderByNo(orderNo: string): Promise<AjaxResult<MhOrderRow>> {
  return apiFetch<MhOrderRow>(`/api/app/order/${encodeURIComponent(orderNo)}`, {
    method: 'GET',
    auth: true,
  });
}

export async function fetchOrderResults(orderNo: string): Promise<AjaxResult<AppOrderResults>> {
  return apiFetch<AppOrderResults>(`/api/app/order/${encodeURIComponent(orderNo)}/results`, {
    method: 'GET',
    auth: true,
  });
}
